<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Employees</h3>
        <v-spacer></v-spacer>
        <v-btn
          class="mb-auto mr-3"
          @click.prevent="toggleAdvanceSearch"
          dark
          fab
          color="secondary"
        >
          <v-icon>mdi-magnify</v-icon></v-btn
        >
        <v-dialog v-if="modelPermissions.create" persistent v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <employee-dialog
            v-if="dialog"
            :employees="employees"
            :item="item"
            :close="close"
          ></employee-dialog>
        </v-dialog>
      </v-card-title>

      <v-data-table
        :server-items-length="employees.total"
        :loading="loading"
        :headers="headers"
        :items="employees.data"
        :options.sync="options"
        :items-per-page="5"
      >
        <template v-slot:top>
          <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-content>
                <v-row>
                  <v-toolbar flat>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                  </v-toolbar>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <!-- New Slot for Charts Button -->
        <template v-if="modelPermissions.view_charts" v-slot:item.charts="{ item }">
          <v-btn text @click="goToCharts(item)" color="primary">
            <v-icon>mdi-graph</v-icon>
          </v-btn>
        </template>

        <template v-if="modelPermissions.view_charts" v-slot:item.calendar="{ item }">
          <v-btn text @click="goToCalendar(item)" color="primary">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-if="modelPermissions.view_charts" class="ma-10" width="100%" flat tile>
      <employees-weekly-totals></employees-weekly-totals>
    </v-card>
  </v-row>
</template>

<script>
import EmployeeDialog from './EmployeeDialog'
import axios from '../../../utils/axios'
import { mapGetters } from 'vuex'
import EmployeesWeeklyTotals from './EmployeesWeeklyTotals.vue'
export default {
  name: 'EmployeeIndex',
  components: {
    EmployeeDialog,
    EmployeesWeeklyTotals,
  },
  data() {
    return {
      advanceSearch: [],
      dialog: false,
      loading: false,
      headers: [
        {
          text: 'id',
          value: 'id'
        },
        {
          text: 'Employee',
          align: 'start',
          value: 'first_name'
        },
        {
          text: 'Role',
          align: 'start',
          value: 'role'
        },
        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false },
        { text: 'Charts', align: 'center', value: 'charts', sortable: false }, 
        { text: 'Calendars', align: 'center', value: 'calendar', sortable: false }, 
      ],

      employees: [],
      options: {},
      item: {},
      search: ''
    }
  },
  methods: {
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
      } else {
        this.advanceSearch = [0]
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getEmployees() {
      this.loading = true
      axios
        .get(
          `api/admin/employees?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}`
        )
        .then(res => {
          this.employees = res.data
          this.loading = false
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting employee with id ', item.id)
        axios
          .delete(`api/admin/employees/${item.id}`)
          .then(res => {
            if (res.data === 1) {
              this.getEmployees()
            }
          })
          .catch(err => console.log(err))
      }
    },
    goToCharts(item) {
      this.$router.push({ name: 'employee-charts', params: { id: `${item.id}` } })
    },
    goToCalendar(item) {
      this.$router.push({ name: 'employee-calendar', params: { id: `${item.id}` } })
    }
  },

  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('employee')
    }
  },

  watch: {
    options: {
      handler() {
        this.getEmployees()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getEmployees()
      },
      deep: true
    },
    search: {
      handler() {
        this.getEmployees()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
